import axios from '../axios.js';

var api = {
  //获取省
  getProvice() {
    return axios.post('index/person/province')
  },
  //获取市
  getCity(params) {
    return axios.post('index/person/city', params)
  },
  //获取区
  getArea(params) {
    return axios.post('index/person/county', params)
  },
  //收货地址
  address(params) {
    return axios.post('index/person/address', params)
  },
  //获取个人信息
  getPersonInfo() {
    return axios.post('index/person/info')
  },
  //修改个人信息
  editPersonInfo(params) {
    return axios.post('index/person/modify_info', params)
  },
  //反馈类型
  getType() {
    return axios.post('index/feedback/type')
  },
  //增加反馈
  addFeedback(params) {
    return axios.post('index/feedback/insert', params)
  },
  //修改密码
  verificationPwd(params) {
    return axios.post('index/user/verificationPwd', params)
  },
  //设置密码
  setPassWord(params) {
    return axios.post('index/user/insertPwd', params)
  },
  //修改密码
  editPassWord(params) {
    return axios.post('index/user/modifyPwd', params)
  },
  //更改手机号
  changePhone(params) {
    return axios.post('index/user/changePhone', params)
  },
  //绑定微信
  wxqrcode(params) {
    return axios.post("index/user/wxqrcode", params);
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/personallnfo.js